import { Component, OnInit, Inject, AfterContentInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-warning-terms-polity',
  templateUrl: './warning-terms-polity.component.html',
  styleUrls: ['./warning-terms-polity.component.scss']
})
export class WarningTermsPolityComponent implements OnInit, AfterContentInit {

  text: string;
  route: string;
  country: string;
  PART1TEXT : string;
  PART2TEXT : string;
  PART3TEXT : string;
  PART4TEXT : string;
  PART5TEXT : string;
  PART6TEXT : string;
  PART7TEXT : string;
  PART8TEXT : string;
  PART9TEXT : string;
  t = sessionStorage.getItem('terms');
  p = sessionStorage.getItem('polity');
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<WarningTermsPolityComponent>,
    private readonly r: Router,
    private translate: TranslateService) { }

  ngOnInit() {
  }

  loadTranslations(): void {
    this.translate.get('TERMS.MODAL.PART1TEXT').subscribe((res: string) => {
      this.PART1TEXT = res;
    });
    this.translate.get('TERMS.MODAL.PART2TEXT').subscribe((res: string) => {
      this.PART2TEXT = res;
    });
    this.translate.get('TERMS.MODAL.PART3TEXT').subscribe((res: string) => {
      this.PART3TEXT = res;
    });
    this.translate.get('TERMS.MODAL.PART4TEXT').subscribe((res: string) => {
      this.PART4TEXT = res;
    });
    this.translate.get('TERMS.MODAL.PART5TEXT').subscribe((res: string) => {
      this.PART5TEXT = res;
    });
    this.translate.get('TERMS.MODAL.PART6TEXT').subscribe((res: string) => {
      this.PART6TEXT = res;
    });
    this.translate.get('TERMS.MODAL.PART7TEXT').subscribe((res: string) => {
      this.PART7TEXT = res;
    });
    this.translate.get('TERMS.MODAL.PART8TEXT').subscribe((res: string) => {
      this.PART8TEXT = res;
    });
    this.translate.get('TERMS.MODAL.PART9TEXT').subscribe((res: string) => {
      this.PART9TEXT = res;
    });
  }

  ngAfterContentInit() {
    this.loadTranslations();
    if (this.data.rapidScore) {
      // RAPIDSCORE
      this.text = this.PART1TEXT;
      if (!this.t) {
        this.text = this.text + this.PART2TEXT;
      }
      if (!this.t && !this.p) {
        this.text = this.text + this.PART3TEXT;
      }
      if (!this.p) {
        this.text = this.text + this.PART4TEXT;
      }
      this.text += this.PART5TEXT;

    
    } else {

      
      this.text = this.PART6TEXT;
      if (!this.t) {
        this.text = this.text + this.PART7TEXT;
      }
      if (!this.t && !this.p) {
        this.text = this.text + this.PART8TEXT;
      }
      if (!this.p) {
        this.text = this.text + this.PART9TEXT;
      }
    }
  }

  goToUrl() {
    this.country = sessionStorage.getItem('country') || 'ES';
    if (!this.t) {
      this.route = (this.country) + '/' + 'terms-conditions' + (this.data ? '?signin=true' : '');
    } else {
      this.route = (this.country) + '/' + 'privacy-polity';
    }
    this.r.navigateByUrl(this.route);
    this.closeModal();
  }

  closeModal() {
    this.dialogRef.close();
  }
}



